import "./index.scss";

import strikeLinks from "./modules/strike-links";
import bounceRate from "./modules/bounce-rate";
import AjaxForm from "../../../components/ajax-form";
import uuidv4 from "uuid";
import lottie from "lottie-web";

window.strikeLinks = strikeLinks;

const emotionsData = {
    fire: {
        // sticker: "/img/site/sticker/fire.json",
        symbol: "🔥",
    },
    water: {
        symbol: "💧",
    },
    shit: {
        symbol: "💩",
    },
};

async function initStickerEmotion(element, path) {
    const response = await fetch(path);
    const json = await response.json();
    const rendererContainer = element.querySelector("[data-lottie]");

    rendererContainer.innerHTML = "";

    const animation = lottie.loadAnimation({
        container: rendererContainer,
        animationData: json,
        autoplay: false,
    });

    element.addEventListener("emotion.update", () => {
        animation.play();
    });
    element.addEventListener("emotion.stop", () => {
        animation.stop();
    });
}

function createEmotionElement({ name, id, count }) {
    const { symbol: text, sticker } = emotionsData[name];
    const element = document.createElement("button");

    element.setAttribute("data-emotion", id);
    element.classList.add("emotion-btn", "mr-4", "appears");
    element.innerHTML = `<span data-lottie>${text}</span><span data-count>${count}</span>`;

    if (sticker) {
        initStickerEmotion(element, sticker);
    }

    return element;
}

function updateEmotions(emotions) {
    for (const { id, count } of emotions) {
        document
            .querySelectorAll(`[data-emotion="${id}"] [data-count]`)
            .forEach((item) => (item.textContent = count));
    }
}

function renderEmotions(emotions, container) {
    let index = 0;

    const { token, path, active } = container.dataset;
    const isActive = active === "1";

    for (const emotion of emotions) {
        const element = createEmotionElement(emotion);
        element.style.animationDelay = index * 50 + "ms";

        if (!isActive) {
            element.classList.add("emotion-btn--inactive");
            element.setAttribute("data-auth", "");
        }

        container.append(element);

        ++index;
    }

    container.addEventListener("click", async (event) => {
        const target = event.target.closest(
            "[data-emotion]:not(.emotion-btn--inactive)"
        );

        if (!target) {
            return;
        }

        const emotion = target.dataset.emotion;
        const data = new FormData();

        data.append("token", token);
        data.append("emotion", emotion);

        const response = await fetch(path, {
            method: "POST",
            body: data,
        });
        const json = await response.json();

        Array.from(container.querySelectorAll("[data-emotion]"))
            .filter((item) => item !== target)
            .forEach((item) => item.dispatchEvent(new Event("emotion.stop")));
        target.dispatchEvent(new Event("emotion.update"));

        updateEmotions(json.emotions);
    });
}

function applyMeta(article, data) {
    for (const key in data) {
        article
            .querySelectorAll(`[data-async-target="${key}"]`)
            .forEach((element) => {
                element.textContent = data[key];

                const parent = element.closest(".async-stub");
                if (parent) {
                    parent.classList.remove("async-stub");
                }
            });
    }

    if (data.emotions) {
        document
            .querySelectorAll("[data-emotions-container]")
            .forEach((container) => renderEmotions(data.emotions, container));
    }

    if ("isLiked" in data) {
        article.querySelectorAll("[data-reaction=like]").forEach((target) => {
            target.classList.toggle("marked", data.isLiked);
        });
    }

    if ("isBookmarked" in data) {
        article
            .querySelectorAll("[data-reaction=bookmark]")
            .forEach((target) => {
                target.classList.toggle("marked", data.isBookmarked);
            });
    }

    if (data.commentsCount === 0) {
        article
            .querySelectorAll("[data-async-target=commentsCount]")
            .forEach((target) => {
                target.textContent = "Обсудить";
            });
    }
}

onDomReady.then(() => {
    window.uuidv4 = uuidv4;

    let article = document.querySelector(".entity");
    if (article) {
        let articleContent = article.querySelector(".entity__content");
        let postId = article.dataset.id;

        if (postId) {
            bounceRate(articleContent, window.bounceRateAction, postId);
        }

        article.addEventListener("click", (e) => {
            if (
                e.target.tagName.toUpperCase() === "IMG" &&
                !e.target.dataset.noFull
            ) {
                showFullImage(e.target.src);
            }
        });
    }

    const url = new URL(window.location.href);
    const focus = url.searchParams.get("focus");

    if (focus) {
        switch (focus) {
            case "comment":
                const textarea = document.querySelector(
                    "[name=commentContent]"
                );

                if (textarea) {
                    textarea.focus();
                }
                break;
        }
    }

    document.querySelectorAll("[data-focus]").forEach((item) => {
        item.addEventListener("click", () => {
            const target = document.querySelector(item.dataset.focus);

            if (target) {
                target.focus();
            }
        });
    });

    let tagsForms = Array.from(
        document.querySelectorAll(".tags-subscribe-form")
    );
    const updateForms = (state) => {
        let checked = state.toDataArray().map((field) => field[0]);
        tagsForms.forEach((form) => {
            let tags = Array.from(form.querySelectorAll("[data-tag]"));
            tags.forEach((tag) => {
                tag.checked = checked.indexOf(tag.name) !== -1;
            });
        });
    };

    tagsForms.forEach((form) => {
        new AjaxForm(form, {
            beforeSubmit: function () {
                let tags = Array.from(this.form.querySelectorAll("[data-tag]"));
                let data = tags.map((input) => {
                    return {
                        id: input.dataset.tag,
                        is_sub: input.checked,
                    };
                });
                let formData = new FormData();
                formData.append("tagsForSubscription", JSON.stringify(data));
                return formData;
            },
            onError: function () {
                updateForms(this.savedState);
            },
            afterSubmit: function () {
                updateForms(this.state);
            },
        });
    });

    if (article.dataset.feedAsync) {
        const path = article.dataset.feedAsync;

        fetch(path)
            .then((res) => res.json())
            .then((json) => {
                const data = json;

                if (!data) {
                    return;
                }

                applyMeta(article, data);
            });
    }
});
